<h1 mat-dialog-title style="text-align: center">{{ dialogTitle }}</h1>
<div mat-dialog-content style="text-align: center">{{ dialogDescription }}</div>
<div mat-dialog-actions>
  @if (displayTextBox) {
    <div >
      <mat-form-field class="example-full-width">
        <input matInput placeholder="Name" [(ngModel)]="name" >
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <input matInput placeholder="MetaData URL" [(ngModel)]="metadataUrl" >
      </mat-form-field>
    </div>
  }
  <button mat-raised-button class="mat-accent" style="margin: 5px" (click)="closeDialog(true)">{{ dialogConfirmButtonText }}</button>
  <button mat-raised-button class="mat-warn" style="margin: 5px" (click)="closeDialog(false)">{{ dialogCancelButtonText }}</button>
</div>
